export default {
	// api请求地址
	baseUrl: 'http://furrific.haodianshop.com',
	
	// 图片域名 - https://furrific.oss-cn-shanghai.aliyuncs.com
	imgDomain: 'http://furrific.haodianshop.com',
	
	// 前端域名
	webDomain: 'http://furrific.haodianshop.com/h5',
	
	// 腾讯地图key
	mpKey: '2MGBZ-C2AR3-3UH3G-3ZL2W-T7TDE-3PBMY',
	
	// 客服
	webSocket: '',
	
	//本地端主动给服务器ping的时间, 0 则不开启 , 单位秒
	pingInterval: 1500
}